export class Versionen {

    public static STAND = '03.11.2026';
    public static VERSION = '3.1.0';
    public static VERSION_CFM = '1.0.1';
    public static VERSION_REV = 'g24';
    // 3.1.0g24 03.11.2026 --> [P, T]     
    // 3.1.0g23 26.10.2026 --> [P, T]     
    // 3.1.0g22 19.10.2026 --> [P, T]     
    // 3.1.0g21 16.10.2026 --> [P, T]     
    // 3.1.0g20 16.10.2026 --> [P, T]     
    // 3.1.0g19 06.10.2026 --> [P, T]     
    // 3.1.0g18 01.10.2026 --> [P, T]     
    // 3.1.0g17 30.09.2026 --> [P, T] 
    // 3.1.0g16 28.09.2026 --> [P, T]    
    // 3.1.0g15 25.09.2026 --> [P, T]    
    // 3.1.0g14 22.09.2026 --> [P, T]    
    // 3.1.0g13 21.09.2026 --> [P, T]    
    // 3.1.0g12 15.09.2026 --> [P, T]    
    // 3.1.0g11 03.08.2026 --> [P, T]
    // 3.1.0g10 12.06.2026 --> [P, T]
    // 3.1.0g9 10.06.2026 --> [P, T]
    // 3.1.0g8 28.05.2026 --> [P, T]
    // 3.1.0g7 21.05.2026 --> [T]
    // 3.1.0g6 18.05.2026 --> [T]
    // 3.1.0g5 18.05.2026 --> [T]
    // 3.1.0g4 11.05.2026 --> [P, T]
    // 3.1.0g3 07.05.2026 --> [T]
    // 3.1.0g2 04.05.2026 --> [P, T]
    // 3.1.0g  02.04.2026 --> [P, T]
    // 3.1.0f  24.03.2026 --> [P, T]
    // 3.1.0e  23.03.2026 --> [P, T]
    // 3.1.0d  20.03.2026 --> [P, T]
    // 3.1.0c  11.03.2026 --> [P, T]
    // 3.1.0b  11.03.2026 --> [P, T]
    // 3.1.0a  10.03.2026 --> [P, T]
    // 3.1.0   04.03.2026 --> [P, T]
    // 3.0.7f  03.03.2026 --> [P, T]
    // 3.0.7e  01.03.2026 --> [P, T]
    // 3.0.7d  28.02.2026 --> [P, T]
    // 3.0.7c  27.02.2026 --> [P, T]
    // 3.0.7a  27.02.2026 --> [P, T]
    // 3.0.7   26.02.2026 --> [P, T]
    // 3.0.6b  16.02.2026 --> [P, T]
    // 3.0.6a  03.02.2026 --> [P, T]
    // 3.0.6   30.01.2026 --> [P, T]
    // 3.0.5a  22.01.2026 --> [T]
    // 3.0.5   16.01.2026 --> [T]
    // 3.0.4j  01.12.2025 --> [T]
    // 3.0.4i  28.11.2025 --> [T]
    // 3.0.4h  17.11.2025 --> [T]
    // 3.0.4g  08.11.2025 --> [P, T]
    // 3.0.4f  07.11.2025 --> [P, T]
    // 3.0.4e  05.11.2025 --> [T]
    // 3.0.4d  03.11.2025 --> [P, T]
    // 3.0.4c  03.11.2025 --> [P, T]
    // 3.0.4b  01.11.2025 --> [T]
    // 3.0.4a  31.10.2025 --> [T]
    // 3.0.4   23.10.2025 --> [T]
    // 3.0.3   01.10.2025 --> [T]
    // 3.0.2   21.08.2025 --> [T, P] ---> Rückgesetzt auf 3.0.2
    // 3.0.4e  18.08.2025 --> [T]
    // 3.0.4d  14.08.2025 --> [T]
    // 3.0.4c  07.08.2025 --> [T]
    // 3.0.4b  30.07.2025 --> [T]
    // 3.0.4a  30.07.2025 --> [T]
    // 3.0.4   29.07.2025 --> [T]
    // 3.0.3   16.07.2025 --> [T]
    // 3.0.2   25.06.2025 --> [T] --> FÜR KMU
    // 3.0.1c  11.06.2025 --> [T,P]
    // 3.0.1b  08.06.2025 --> [T,P]
    // 3.0.1a  06.06.2025 --> [T,P]
    // 3.0.1  05.06.2025 --> [T]
    // 3.0.0f  27.05.2025 --> [P, T]
    // 3.0.0e  26.05.2025 --> [P, T]
    // 3.0.0d  25.05.2025 --> [P, T]
    // 3.0.0c  21.05.2025 --> [P, T]
    // 3.0.0b  19.05.2025 --> [P, T]
    // 3.0.0a  18.05.2025 --> [P, T]
    // 3.0.0   17.05.2025 --> [P, T]
    // 2.11.20   16.05.2025 --> [P, T]
    // 2.11.19   16.05.2025 --> [P, T]
    // 2.11.18   16.05.2025 --> [P, T]
    // 2.11.17   16.05.2025 --> [P, T]
    // 2.11.16   15.05.2025 --> [P, T]
    // 2.11.15   14.05.2025 --> [T]
    // 2.11.14   14.05.2025 --> [T]
    // 2.11.13   13.05.2025 --> [T]
    // 2.11.12   12.05.2025 --> [T]
    // 2.11.11   12.05.2025 --> [T]
    // 2.11.10   10.05.2025 --> [T]
    // 2.11.9    07.05.2025 --> [T]
    // 2.11.8    06.05.2025 --> [T]
    // 2.11.7    28.04.2025 --> [T]
    // 2.11.6    25.04.2025 --> [T]
    // 2.11.5    24.04.2025 --> [T]
    // 2.11.4    15.04.2025 --> [T]
    // 2.11.3    11.04.2025 --> [T]
    // 2.11.2    08.04.2025 --> [T]
    // 2.11.1    03.04.2025 --> [T]
    // 2.11.0a   25.03.2025 --> [T]
    // 2.11.0    21.03.2025 --> [T]
    // 2.10.17   26.02.2025 --> [P, T]
    // 2.10.16   26.02.2025 --> [P, T]
    // 2.10.15   26.02.2025 --> [T]
    // 2.10.14   26.02.2025 --> [T]
    // 2.10.13a  25.02.2025 --> [T]
    // 2.10.13   19.02.2025 --> [T]
    // 2.10.12   18.02.2025 --> [T]
    // 2.10.11   13.02.2025 --> [P, T]
    // 2.10.10   10.02.2025 --> [P, T]
    // 2.10.9    09.02.2025 --> [T]
    // 2.10.8    02.02.2025 --> [P, T]
    // 2.10.7a   31.01.2025 --> [T]
    // 2.10.7    28.01.2025 --> [P, T]
    // 2.10.6    27.01.2025 --> [P, T]
    // 2.10.5    23.01.2025 --> [P, T]
    // 2.10.4    21.01.2025 --> [T]
    // 2.10.3    09.01.2025 --> [T]
    // 2.10.2    08.01.2025 --> [T]
    // 2.10.1a   06.01.2025 --> [P, T]
    // 2.10.1    05.12.2024 --> [P, T]
    // 2.10.0    04.12.2024 --> [P, T]
    // 2.9.19    03.12.2024 --> [T]
    // 2.9.18    02.12.2024 --> [T]
    // 2.9.17a   29.11.2024 --> [T]
    // 2.9.17    27.11.2024 --> [T]
    // 2.9.16    28.10.2024 --> [P, T]
    // 2.9.15    26.10.2024 --> [P, T]
    // 2.9.14    21.10.2024 --> [T]
    // 2.9.13    16.09.2024 --> [P, T]
    // 2.9.12    06.09.2024 --> [P, T]
    // 2.9.11    06.09.2024 --> [T]
    // 2.9.10a   06.08.2024 --> [T]
    // 2.9.10    06.08.2024 --> [T]
    // 2.9.9     02.08.2024 --> [T]
    // 2.9.8     16.07.2024 --> [T]
    // 2.9.7a    09.07.2024 --> [P, T] --> Patch-Branch
    // 2.9.7     24.06.2024 --> [P, T]
    // 2.9.6     17.06.2024 --> [T]
    // 2.9.5     03.06.2024 --> [T]
    // 2.9.4     29.05.2024 --> [P, T]
    // 2.9.3     23.05.2024 --> [P, T]
    // 2.9.2     21.05.2024 --> [P, T]
    // 2.9.1     14.05.2024 --> [P, T]
    // 2.9.0     14.05.2024 --> [T]
    // 2.8.12-   25.04.2024 --> [T]
    // 2.8.11-   25.04.2024 --> [T]
    // 2.8.10-   19.04.2024 --> [T]
    // 2.8.9 -   18.04.2024 --> [T]
    // 2.8.8 -   12.04.2024 --> [T]
    // 2.8.7 -   26.03.2024 --> [P, T]
    // 2.8.6 -   23.03.2024 --> [T]
    // 2.8.5 -   22.03.2024 --> [T]
    // 2.8.4 -   19.03.2024 --> [T]
    // 2.8.3 -   13.03.2024 --> [T]
    // 2.8.2 -   06.03.2024 --> [T]
    // 2.8.1 -   28.02.2024 --> [P, T]
    // 2.8.0 -   26.02.2024 --> [P, T]
    // 2.7.17 -  22.02.2024 --> [T]
    // 2.7.16 -  20.02.2024 --> [T]
    // 2.7.15 -  19.02.2024 --> [T]
    // 2.7.14 -  15.02.2024 --> [T]
    // 2.7.13 -  02.02.2024 --> [P, T]
    // 2.7.12 -  01.02.2024 --> [T]
    // 2.7.12 -  01.02.2024 --> [T]
    // 2.7.11 -  31.01.2024 --> [T]
    // 2.7.10 -  28.01.2024 --> [T]
    // 2.7.9 -   10.01.2024 --> [P, T]
    // 2.7.8 -   09.01.2024 --> [T]
    // 2.7.7 -   20.12.2023 --> [T]
    // 2.7.6 -   17.12.2023 --> [T]
    // 2.7.5 -   04.12.2023 --> [T]
    // 2.7.4 -   21.11.2023 --> [T]
    // 2.7.3 -   07.11.2023 --> [P, T]
    // 2.7.2 -   07.11.2023 --> [P, T]
    // 2.7.1 -   06.11.2023 --> [P, T]
    // 2.7.0 -   02.11.2023 --> [T]
    // 2.6.17 -  01.11.2023 --> [T]
    // 2.6.16 -  31.10.2023 --> [T]
    // 2.6.15 -  20.10.2023 --> [T]
    // 2.6.14 -  13.10.2023 --> [T]
    // 2.6.13 -  04.10.2023 --> [T]
    // 2.6.12 -  21.09.2023 --> [T]
    // 2.6.11 -  04.09.2023 --> [T]
    // 2.6.10 -  01.09.2023 --> [T]
    // 2.6.9 -  30.08.2023 --> [T]
    // 2.6.8 -  28.08.2023 --> [T]
    // 2.6.7 -  12.08.2023 --> [P, T]
    // 2.6.6 -  10.08.2023 --> [P, T]
    // 2.6.5 -  09.08.2023 --> [P, T]
    // 2.6.4 -  08.08.2023 --> [P, T]
    // 2.6.3 -  08.08.2023 --> [P, T]
    // 2.6.2 -  07.08.2023 --> [P, T]
    // 2.6.1 -  07.08.2023 --> [P, T]
    // 2.6.0 -  06.08.2023 --> [P, T]
    // 2.5.9 -  02.08.2023 --> [T]
    // 2.5.8 -  01.08.2023 --> [T]
    // 2.5.7 -  21.07.2023 --> [T]
    // 2.5.6c - 18.07.2023 --> [T]
    // 2.5.6b - 18.07.2023 --> [T]
    // 2.5.6a - 17.07.2023 --> [T]
    // 2.5.6 - 17.07.2023 --> [T]
    // 2.5.5 - 27.06.2023 --> [T]
    // 2.5.4 - 13.06.2023 --> [T]
    // 2.5.3 - 02.06.2023 --> [T]
    // 2.5.2 - 23.05.2023 --> [T]
    // 2.5.1 - 23.05.2023 --> [T, P]
    // 2.5.0 - 22.05.2023 --> [T, P]
    // 2.4.31 - 22.05.2023 --> [T, P]
    // 2.4.30 - 22.05.2023 --> [T, P]
    // 2.4.29 - 20.05.2023 --> [T, P]
    // 2.4.28 - 16.05.2023 --> [T]
    // 2.4.27 - 11.05.2023 --> [T]
    // 2.4.26 - 04.05.2023 --> [T]
    // 2.4.25 - 25.04.2023 --> [T]
    // 2.4.24 - 21.04.2023 --> [T]
    // 2.4.23 - 19.04.2023 --> [T]
    // 2.4.22 - 17.04.2023 --> [T, P]
    // 2.4.21 - 17.04.2023 --> [T, P]
    // 2.4.20 - 14.04.2023 --> [T, P]
    // 2.4.19 - 14.04.2023 --> [T]
    // 2.4.18 - 13.04.2023 --> [T]
    // 2.4.17 - 12.04.2023 --> [T]
    // 2.4.16 - 02.04.2023 --> [T, P]
    // 2.4.15 - 31.03.2023 --> [T, P]
    // 2.4.14 - 31.03.2023 --> [P]
    // 2.4.13 - 31.03.2023 --> [P]
    // 2.4.12 - 30.03.2023 --> [P]
    // 2.4.11 - 30.03.2023 --> [T]
    // 2.4.10 - 29.03.2023 --> [T]
    // 2.4.9 - 21.03.2023 --> [T]
    // 2.4.8 - 17.03.2023 --> [T]
    // 2.4.7 - 07.03.2023 --> [T]
    // 2.4.5 - 01.03.2023 --> [T]
    // 2.4.4 - 21.02.2023 --> [T]
    // 2.4.3 - 16.01.2023 --> [T]
    // 2.4.2 - 10.01.2023 --> [T]
    // 2.4.1 - 12.12.2022 --> [T]
    // 2.4.0 - 29.11.2022 --> [T]
    // 2.3.1 - 16.11.2022 --> [P]
    // 2.3 - 20.10.2022 --> [T, P]
    // 2.3rc1 - 18.10.2022 --> [T]
    // 2.2.5rc1 - 17.10.2022 --> [T]
    // 2.2.4z - 16.10.2022 --> [T]
    // 2.2.4y - 13.10.2022 --> [T]
    // 2.2.4x - 11.10.2022 --> [T]
    // 2.2.4w - 10.10.2022 --> [T]
    // 2.2.4v - 06.10.2022 --> [T]
    // 2.2.4u - 05.10.2022 --> [T]
    // 2.2.4t - 04.10.2022 --> [T]
    // 2.2.4s - 01.10.2022 --> [T]
    // 2.2.4r - 29.09.2022 --> [T]
    // 2.2.4q - 28.09.2022 --> [T]
    // 2.2.4p - 20.09.2022 --> [T]
    // 2.2.4o - 20.09.2022 --> [T]
    // 2.2.4n - 14.09.2022 --> [T]
    // 2.2.4m - 06.09.2022 --> [T]
    // 2.2.4l - 16.08.2022 --> [T]
    // 2.2.4k - 03.08.2022 --> [T]
    // 2.2.4j - 27.07.2022 --> [T]
    // 2.2.4i - 20.07.2022 --> [T]
    // 2.2.4h - 05.07.2022 --> [T]
    // 2.2.4g - 04.07.2022 --> [T]
    // 2.2.4f - 04.07.2022 --> [T]
    // 2.2.4d - 01.07.2022 --> [T]
    // 2.2.4c - 30.06.2022 --> [T]
    // 2.2.4b - 30.06.2022 --> [T]
    // 2.2.4a - 28.06.2022 --> [T]
    // 2.2.3a - 23.06.2022 --> [P]
    // 2.2.4 - 22.06.2022 --> [T]
    // 2.2.3 - 21.06.2022 --> [P]
    // 2.2.2 - 15.05.2022 --> [P]
    // 2.2.1c - 30.05.2022 --> [P]
    // 2.2.1b - 30.05.2022 --> [T]
    // 2.2.1a - 25.05.2022 --> [P]
    // 2.2.1 - 25.05.2022 --> [P]
    // 2.2.0 - 24.05.2022 --> [P]
    // 2.2.0 - 22.05.2022 --> [T]
    // 2.1.6c - 18.05.2022 --> [T]
    // 2.1.6b - 11.05.2022 --> [T]
    // 2.1.6a - 02.05.2022 --> [T]
    // 2.1.6 -  26.04.2022 --> [T]
    // 2.1.5 -  05.04.2022 --> [T]
    // 2.1.4e - 30.03.2022 --> [T]
    // 2.1.4d - 30.03.2022 --> [T]
    // 2.1.4c - 24.03.2022 --> [T]
    // 2.1.4b - 21.03.2022 --> [T]
    // 2.1.4a - 11.03.2022 --> [T]
    // 2.1.4 -  09.03.2022 --> [T]
    // 2.1.3a - 23.02.2022 --> [T]
    // 2.1.3 -  17.02.2022 --> [T]
    // 2.1.2a - 18.01.2022 --> [T, P] Hotfix-Release
    // 2.1.2 -  13.01.2022 --> [T, P]
    // 2.1.1 -  12.01.2022 --> [T, P]  aktueller API-Stand auf dem P-System
    // 2.1.0b - 12.01.2022 --> [T]
    // 2.1.0a - 11.01.2022 --> [T]
    // 2.1.0  - 10.01.2022 --> [T]
    // 2.0.24 - 05.01.2022 --> [T]
    // 2.0.23 - 20.12.2021 --> [T]
    // 2.0.22 - 14.12.2021 --> [T]
    // 2.0.21 - 03.12.2021 --> [T]
    // 2.0.20 - 16.11.2021 --> [T]
    // 2.0.19 - 16.11.2021 --> [T]
    // 2.0.17b- 16.11.2021 --> [P] Hotfix-Release
    // 2.0.18 - 04.11.2021 --> [T]
    // 2.0.17 - 20.10.2021 --> [T,P] aktueller API-Stand auf dem P-System
    // 2.0.16 - 19.10.2021 --> [T,P]
    // 2.0.15 - 27.09.2021 --> [T,P]
    // 2.0.14 - 20.09.2021 --> [T,P]
    // 2.0.13 - 20.09.2021 --> [T,P]
    // 2.0.11 - 01.09.2021 --> [T,P]
    // 2.0.10 - 20.07.2021 --> [T,P]
    // 2.0.9  - 05.07.2021 --> [T,P]
    // 2.0.7  - 06.05.2021 --> [T,P]
    // 2.0.6  - 06.05.2021 --> [T,P]
    // 2.0.5  - 04.05.2021 --> [T,P]
    // 2.0.2  - 25.04.2021 --> [T,P]
    // 2.0.1  - 15.04.2021 --> [T,P]
    // 2.0    - 17.02.2021 --> [T,P]
}
